
import './App.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
// import Home from './Pages/Home'
// import About from './Pages/About';
// import Service from './Pages/Services';
// import Contact, { contactFormData } from './Pages/Contact';


import AppLayout from './AppLayout/AppLayout';
import Errorpage from './AppLayout/ErrorPage';
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Shop from './Pages/Shop';
import TrainingClasses from './Pages/TrainingClasses';
import NewsArticles from './Pages/NewsArticles';
import ContactUs from './Pages/ContactUs';
import NewsArticleDetail from './components/DetailsPages/NewsArticleDetail';
import ShopDetail from './components/DetailsPages/ShopDetail';
import GuidedMastersDetail from './components/DetailsPages/GuidedMastersDetail';
import AstrologerDetail from './components/DetailsPages/AstrologerDetail';
import Login from './components/Login/Login';
import EnrollmentForm from './components/EnrollmentForm/EnrollmentForm';
import ConsultationForm from './components/ConsultationForm/ConsultationForm';
import CheckoutForm from './components/CheckoutForm/CheckoutForm';
import WishlistPage from './Pages/WishlistPage';
import CartPage from './Pages/CartPage';
import OrderHistoryPage from './Pages/OrderHistoryPage';
import AdminLayout from './admin/components/AdminLayout';
import Dashboard from './admin/pages/dashboard/Dashboard';
import ServiceCategory from './admin/pages/serviceCategory/ServiceCategory';
import ServiceSubCategory from './admin/pages/serviceSubCategory/ServiceSubCategory';
import ServiceMaster from './admin/pages/serviceMaster/ServiceMaster';
import Specialization from './admin/pages/specialization/Specialization';
import UserRole from './admin/pages/userRole/UserRole';
import CreateLogin from './admin/pages/createLogin/CreateLogin';
import OrderMaster from './admin/pages/orderMaster/OrderMaster';
import OrderStatusMaster from './admin/pages/orderStatus/OrderStatusMaster';
import ShipmentTracking from './admin/pages/shipmentTracking/ShipmentTracking';
import CallToActionMaster from './admin/pages/callToAction/CallToActionMaster';
import LocationType from './admin/pages/locationType/LocationType';
import Location from './admin/pages/location/Location';
import AssetType from './admin/pages/assetType/AssetType';
import AssetSourceLocation from './admin/pages/assetSourceLocation/AssetSourceLocation';
import AssetInventory from './admin/pages/assetInventory/AssetInventory';
import Wishlist from './admin/pages/wishlist/Wishlist';
import Cart from './admin/pages/cart/Cart';
import ReviewRating from './admin/pages/reviewRating/ReviewRating';
import UserMaster from './admin/pages/userMaster/UserMaster';
import VerifierUserLogins from './admin/pages/userMaster/VerifierUserLogins';
import Advertisement from './admin/pages/advertisement/Advertisement';
import AddressType from './admin/pages/addressType/AddressType';
import AddressMaster from './admin/pages/addressMaster/AddressMaster';
import SocialMediaMaster from './admin/pages/socialMediaMaster/SocialMediaMaster';
import UserSocialMedia from './admin/pages/userSocialMedia/UserSocialMedia';
import UserAwardsCertificates from './admin/pages/userAwardsCertificates/UserAwardsCertificates';
import MediaTypeMaster from './admin/pages/mediaTypeMaster/MediaTypeMaster';
import UserNewsMedia from './admin/pages/userNewsMedia/UserNewsMedia';
import KycMaster from './admin/pages/kycMaster/KycMaster';
import UserKyc from './admin/pages/userKyc/UserKyc';
import EstablishmentKyc from './admin/pages/establishmentKyc/EstablishmentKyc';
import BankAccountType from './admin/pages/bankAccountType/BankAccountType';
import UserBankAccount from './admin/pages/userBankAccount/UserBankAccount';
import DevDarshan from './admin/pages/devDarshan/DevDarshan';
import OnlineClassesList from './admin/pages/onlineClasses/OnlineClassesList';
import OnlineClassForm from './admin/pages/onlineClasses/OnlineClassForm';
import OnlineClassDetails from './admin/pages/onlineClasses/OnlineClassDetails';
import { PORTAL_ROUTE_SEGMENTS } from './admin/utils/auth';

const portalChildren = [
  { index: true, element: <Dashboard /> },
  { path: 'dashboard', element: <Dashboard /> },
  { path: 'orders', element: <OrderMaster /> },
  { path: 'order-master', element: <OrderMaster /> },
  { path: 'order-status', element: <OrderStatusMaster /> },
  { path: 'shipment-tracking', element: <ShipmentTracking /> },
  { path: 'call-to-action', element: <CallToActionMaster /> },
  { path: 'service-category', element: <ServiceCategory /> },
  { path: 'service-sub-category', element: <ServiceSubCategory /> },
  { path: 'services-master', element: <ServiceMaster /> },
  { path: 'asset-type', element: <AssetType /> },
  { path: 'asset-source-location', element: <AssetSourceLocation /> },
  { path: 'asset-inventory', element: <AssetInventory /> },
  { path: 'wishlist', element: <Wishlist /> },
  { path: 'cart', element: <Cart /> },
  { path: 'review-rating', element: <ReviewRating /> },
  { path: 'user-role', element: <UserRole /> },
  { path: 'user-master', element: <UserMaster /> },
  { path: 'user-details', element: <VerifierUserLogins /> },
  { path: 'create-login', element: <CreateLogin /> },
  { path: 'specialization', element: <Specialization /> },
  { path: 'location-type', element: <LocationType /> },
  { path: 'locations', element: <Location /> },
  { path: 'advertisements', element: <Advertisement /> },
  { path: 'address-type', element: <AddressType /> },
  { path: 'address-master', element: <AddressMaster /> },
  { path: 'social-media-master', element: <SocialMediaMaster /> },
  { path: 'user-social-media', element: <UserSocialMedia /> },
  { path: 'user-awards-certificates', element: <UserAwardsCertificates /> },
  { path: 'media-type', element: <MediaTypeMaster /> },
  { path: 'user-news-media', element: <UserNewsMedia /> },
  { path: 'kyc-master', element: <KycMaster /> },
  { path: 'user-kyc', element: <UserKyc /> },
  { path: 'establishment-kyc', element: <EstablishmentKyc /> },
  { path: 'bank-account-type', element: <BankAccountType /> },
  { path: 'user-bank-account', element: <UserBankAccount /> },
  { path: 'dev-darshan', element: <DevDarshan /> },
  { path: 'online-classes', element: <OnlineClassesList /> },
  { path: 'create-online-class', element: <OnlineClassForm /> },
  { path: 'online-classes/create', element: <OnlineClassForm /> },
  { path: 'online-classes/:id', element: <OnlineClassDetails /> },
  { path: 'online-classes/:id/edit', element: <OnlineClassForm /> },
  { path: 'online-classes/:id/attendance', element: <OnlineClassDetails /> },
];

const portalRoutes = PORTAL_ROUTE_SEGMENTS.map((segment) => ({
  path: `/${segment}`,
  element: <AdminLayout />,
  errorElement: <Errorpage />,
  children: portalChildren,
}));

function App() {
  const myRouter = createBrowserRouter([
    {
      path: '/',
      element: <AppLayout />,
      errorElement: <Errorpage/>,
      children: [
        {
          path: '/',
          element: <Home/>

        },
        {
          path: '/login',
          element: <Login/>

        },
        {
          path: '/enroll',
          element: <EnrollmentForm/>

        },
        {
          path: '/consult',
          element: <ConsultationForm/>

        },
        {
          path: '/about',
          element: <About />
        },
        {
          path: '/services',
          element: <Services />,
        },
        {
          path: '/shop',
          element: <Shop />,
        },
        {
          path: '/shop/:id',
          element: <ShopDetail />,
        },
        {
          path: '/training-classes',
          element: <TrainingClasses />,
        },
        {
          path: '/guided-by-masters',
          element: <GuidedMastersDetail />,
        },
        {
          path: '/astrologer/:id',
          element: <AstrologerDetail />,
        },
        {
          path: '/order-page',
          element: <CheckoutForm />,
        },
        {
          path: '/wishlist',
          element: <WishlistPage />,
        },
        {
          path: '/cart',
          element: <CartPage />,
        },
        {
          path: '/order-history',
          element: <OrderHistoryPage />,
        },
        {
          path: '/news-articles',
          element: <NewsArticles />,
        },
        {
          path: '/news-articles/:id',
          element: <NewsArticleDetail />,
        },
        {
          path: '/contact',
          element: <ContactUs />,
        },
      ]
    },
    ...portalRoutes,
  ]);
  return <RouterProvider router={myRouter} />
}
export default App
